import { useMemo } from "react";
import CommonGrid from "../CommonGrid/CommonGrid";
import {
  getAlertsGridColumns,
  alertsGridFilters,
  alertsGridGlobalFilterFields,
} from "./gridConfig";
import ExportSelectedRows from "../../ExportCSV";
import "./ModuleGrids.scss";

const AlertsGrid = ({
  data = [],
  mode = "min",
  dataKey = "AWMProjectID",
  emptyMessage = "No alerts data found.",
  tableProps = {},
  rows = 20,
  paginator,
  onNavigate,
  title = ""
}) => {
  const columns = useMemo(() => getAlertsGridColumns(mode), [mode]);
  return (
    <>
      {mode === "max" && (
        <div className="task-grid-filters my-3">
          <ExportSelectedRows
            allData={data}
            selectedRows={[]}
            headers={columns?.map(col => col?.field)}
            filename={`${title}_Records`}
          />
        </div>
      )}
      <CommonGrid
        data={data}
        columns={columns}
        mode={mode}
        filters={mode === "max" ? alertsGridFilters : undefined}
        globalFilterFields={mode === "max" ? alertsGridGlobalFilterFields : undefined}
        dataKey={dataKey}
        emptyMessage={emptyMessage}
        rows={rows}
        paginator={mode === "max" ? paginator : undefined}
        tableProps={tableProps}
        showACPFilter={true}
      />
    </>
  );
};

export default AlertsGrid;
